import { render } from "./ThankYouView.vue?vue&type=template&id=70a3aa14&scoped=true"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"

import "./ThankYouView.vue?vue&type=style&index=0&id=70a3aa14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a3aa14"]])

export default __exports__